import { AxiosInstance } from "axios";
import { IContent } from "./interfaces";

export function getHeaderBannerBuilder(apiClient: AxiosInstance) {
  return async function getHeaderBanner(options: {
    lang?: string;
  }): Promise<IContent.HeaderBannerResponse | null> {
    try {
      const response = await apiClient.get("/header-banners/", {
        params: options,
      });
      return response.data;
    } catch (error) {
      return null;
    }
  };
}
